import React from "react";
import {
  AddCmpProjectDialogContent,
  AddCmpProjectDialogStateProvider,
} from ".";

export const AddCmpProjectDialog = () => {
  return (
    <AddCmpProjectDialogStateProvider>
      <AddCmpProjectDialogContent></AddCmpProjectDialogContent>
    </AddCmpProjectDialogStateProvider>
  );
};
